import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-comingsoon',
    templateUrl: './comingsoon.component.html',
    styleUrls: ['./comingsoon.component.css'],
    standalone: false
})
export class ComingsoonComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
